import axios from 'axios';
import { AwardIcon, Axis3D, Plus } from 'lucide-react';
import React, { useContext, useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import apiUrl from '../../Config';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    Box, Button, Typography, IconButton, CircularProgress,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper,
    Divider,
} from '@mui/material';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';

const DisplayBanner = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([])
    const [errors, setErrors] = useState('')


    const getBanners = async () => {
        try {
            const response = await axios.get(apiUrl + `/banners/getbanners`)
            if (response?.data?.status === true) {
                setBanners(response?.data?.banners)
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error getting banners")
        }
    }
    useEffect(() => {
        getBanners()
    }, [])
    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await axios.delete(`${apiUrl}/banners/deletebanner/${itemIdToDelete}`);
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || "Service deleted successfully")
                getBanners()
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error deleting service")
        }
        finally {
            setLoading(false)
        }
    };

    const handleEditClick = (banners) => {
        navigate('/create-edit-banner', { state: { banners } });
    };
    const handleAddClick = () => {
        navigate('/create-edit-banner');
    };
    return (
        <>
            <Box sx={{ backgroundColor: "", padding: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3">Banners</Typography>
                    <Button
                        variant="contained"
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                        onClick={handleAddClick}
                    >
                        <Plus size={23} />
                        <Typography>Add Banner</Typography>
                    </Button>
                </Box>

                <Divider sx={{ marginBottom: 3 }} />
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Image</strong></TableCell>
                                    <TableCell><strong>Name</strong></TableCell>
                                    <TableCell><strong>Description</strong></TableCell>
                                    <TableCell><strong>Order</strong></TableCell>
                                    <TableCell><strong>Is Active</strong></TableCell>
                                    <TableCell align='right'><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {banners.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No banners found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    banners.map((banners) => (
                                        <TableRow key={banners.id}>
                                            <TableCell>
                                                <img
                                                    src={banners.bannerUrl}
                                                    alt={banners?.name}
                                                    style={{ width: 70, height: 70, borderRadius: 5 }}
                                                />
                                            </TableCell>
                                            <TableCell>{banners?.bannerTitle}</TableCell>
                                            <TableCell>
                                                {banners?.bannerDescription?.length > 50
                                                    ? banners?.bannerDescription.slice(0, 50) + '...'
                                                    : banners?.bannerDescription}
                                            </TableCell>
                                            <TableCell>{banners.bannerOrder}</TableCell>

                                            <TableCell>{banners?.isActive === true ? "true" : "false"}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                    <IconButton onClick={() => handleEditClick(banners)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton color="error" onClick={() => confirmDelete(banners.id)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {errors && <Typography variant='body2' color='error'>{errors}</Typography>}

                <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />


            </Box>
        </>
    )
}

export default DisplayBanner